module.exports = ".geo-card__content span {\n    color: inherit;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/bens/frotas/frota-detail/frota-detail.component.css
 ** module id = 393
 ** module chunks = 0
 **/